/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React from 'react'
import {withTranslation} from 'react-i18next'
import {
    Grid,
    Card,
    CardContent,
    CardActions
} from "@material-ui/core";

import {useThemeData} from '../../context/ThemeDataContext'
/* EQUESTRIAN photos*/

function PhotoCard(props) {
    const {site_id} = useThemeData().themeData.site;
    const {primary_color_2, font_family} = useThemeData().themeData.site.theme;
    const PHOTO_URL_NORMAL = process.env.REACT_APP_PHOTO_NORMAL_URL
    const {id, file_name} = props.data

    return (
        <Card className="photo-card" style={{
            fontFamily: `${font_family}`,
            color: `${primary_color_2}`,
            border: 'none',
            backgroundColor: 'transparent',
            minWidth: '100%',
        }}>
            <CardContent
                className="photoCard-body"
                style={{
                    minHeight: '24vh',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    // border: 'solid 1px #707070',
                    maxWidth: 'fit-content',
                    margin: '0rem 1rem 0rem 1rem',
                    placeSelf: 'center',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    display: 'block'
                }}
            >
                <img
                    // style={{ border: `1px solid ${background_color_5}` }}
                    alt={file_name}
                    src={`${PHOTO_URL_NORMAL}${site_id}/${props.data.folder.folder_id}/0/0/0/0/${id}/${file_name}`}
                    className="small-image-size"
                />

            </CardContent>
            <CardActions style={{padding: '0.1rem', border: 'none', backgroundColor: 'transparent' }}>
                <Grid container style={{margin: '0rem'}}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{padding: '0.1rem', textAlign: 'center'}}>
                        <b>{id}</b>
                    </Grid>
                </Grid>
            </CardActions>
        </Card>
    )

}

export default React.memo(withTranslation('home')(PhotoCard))
